import React from "react";
import './footer.css';
import logo from '../assets/logo_text.png'
import androidLogo from '../assets/img/icon/playStore.png'; // Replace with your Android logo path
import iosLogo from '../assets/img/icon/appleStore.png'; // Replace with your iOS logo path
import { translateUiText } from '../i18n';

function Footer({ locale = 'en' }) {
    return (
        <div className="footer">
                
                <div className="logo-container">
                <img src={logo} alt={translateUiText(locale, 'foodAllergyCardAlt')} className="footer-logo" />
               
                </div>

                <div className="app-download-section">
             
          
                <p>{translateUiText(locale, 'downloadApp')}</p>
                <a
                href='https://apps.apple.com/ch/app/food-allergy-card/id6448350429' target="_blank" rel="noopener noreferrer">
                        <img  className="store-logo"  src={androidLogo} alt={translateUiText(locale, 'playStoreAlt')} />
                    </a>
                    <a 
                    
                    href="https://apps.apple.com/us/app/food-allergy-card/id6448350429" target="_blank" rel="noopener noreferrer">
                        <img  className="store-logo"  src={iosLogo} alt={translateUiText(locale, 'appStoreAlt')} />
                    </a>

                </div>

            <div className="first-componenet-content">

             

        

          
            </div>


                <div className="copyright">
                    &copy; {new Date().getFullYear()} Food Allergy Card. {translateUiText(locale, 'allRightsReserved')}
                </div>
            </div>

    );
}

export default Footer;
